import { Component } from "react";

import { withTranslation } from "react-i18next";
import type { WithTranslation } from "react-i18next";
import { connect } from "react-redux";

import { withTheme } from "styled-components";
import type { DefaultTheme } from "styled-components";

import { OpenAPI } from "simplydo/interfaces";
import { Grid, Icon } from "simplydo/react/ui";

import type { FeedAchievementItem, FeedCardSharedProps } from "../types";
import FeedCard from "./FeedCard";

type CardLeftProps = { achievement: FeedAchievementItem; theme: DefaultTheme };

const CardLeft = withTheme(({ achievement, theme }: CardLeftProps) => (
  <Grid.Column stretched width={12} verticalAlign="middle">
    <div className="cover-and-text">
      <Icon
        style={{ color: theme.primaryColour, fontSize: "3em" }}
        name="trophy"
        size="big"
      />
      <div style={{ marginLeft: 5, fontSize: "1.2em" }}>
        <span style={{ fontWeight: 600 }}>{achievement.name}</span>
        <br />
        <span>{achievement.description}</span>
      </div>
    </div>
  </Grid.Column>
));

type AchievementCardOwnProps = FeedCardSharedProps & {
  achievement: FeedAchievementItem;
  profileUser?: OpenAPI.Schemas["PreparedUser"];
};

type AchievementCardProps = AchievementCardOwnProps &
  WithTranslation & { user?: OpenAPI.Schemas["PreparedUser"] };

class AchievementCard extends Component<AchievementCardProps> {
  render() {
    const { achievement, user, profileUser, feedType } = this.props;
    const you = profileUser || user;
    return (
      <FeedCard
        user={you}
        feedType={feedType}
        action="activityFeed.achievements.action"
        date={achievement.achievedAt}
        toLink="/achievements"
        type="ACHIEVEMENTS"
        cardContent={<CardLeft achievement={achievement} />}
      />
    );
  }
}

const mapStateToProps = (state: {
  user?: OpenAPI.Schemas["PreparedUser"];
}) => ({ user: state.user });

const AchievementCardContainer = connect(mapStateToProps)(AchievementCard);

export default withTranslation()(AchievementCardContainer);
